import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/ui/components/ui/button';

interface Props {
	type: 'retire' | 'forfeit' | 'withdraw' | 'undo';
	isUndo: boolean;
	teamName: string;
	side: 'away' | 'home';
	gameNumber: number;
	onCancel: () => void;
	onConfirm: () => void;
	originalActionType?: 'retire' | 'forfeit' | 'withdraw'; // For undo cases
}

export const ForfeitAndRetireModalContent = ({ type, teamName, side, gameNumber, onCancel, onConfirm, isUndo, originalActionType }: Props) => {
	const getActionText = () => {
		if (type === 'undo' && originalActionType) {
			return originalActionType;
		}
		if (type === 'retire') return 'retire';
		if (type === 'forfeit') return 'forfeit';
		if (type === 'withdraw') return 'withdraw';
		return '';
	};

	const getConfirmationText = () => {
		const actionText = getActionText();
		if (!isUndo) {
			return `Please confirm that you are ${actionText === 'withdraw' ? 'withdrawing from' : `${actionText}ing`} Game ${gameNumber}`;
		} else {
			const undoActionText = actionText === 'withdraw' ? 'withdrawal from' : actionText;
			return `Please confirm that you are undoing the ${undoActionText} of Game ${gameNumber}`;
		}
	};

	return (
		<div className="flex flex-col gap-6">
			<div className="relative w-full">
				<p className="text-black text-2xl font-medium">
					Confirm {isUndo ? 'undo ' : ''}
					{getActionText()}
				</p>
				<FontAwesomeIcon
					icon={faClose}
					className="cursor-pointer text-xl font-normal absolute right-0 top-1/2 -translate-y-1/2"
					onClick={onCancel}
				/>
			</div>
			<p className="text-orange-500 font-semibold text-lg">
				{teamName} - {side === 'away' ? 'Away' : 'Home'}
			</p>
			<p className="text-gray-900 font-semibold text-sm">{getConfirmationText()}</p>
			<div className="flex gap-4 w-full justify-end">
				<Button className={`h-10 w-[7.5rem] text-sm font-semibold leading-5`} onClick={onCancel} variant="outline">
					Close
				</Button>
				<Button type="submit" onClick={onConfirm} className={`h-10 w-[7.5rem] text-sm font-semibold leading-5 disabled:cursor-not-allowed`}>
					Save
				</Button>
			</div>
		</div>
	);
};
